import { PublicTeamGq, PublicTeamGqProps } from './PublicTeamGq';

export interface PublicUserGq {
  id: number;
  email: string;
  givenName?: string;
  familyName?: string;
  picture?: string;
  team: PublicTeamGq;
}

export const PublicUserGqProps = `
  id
  email
  picture
  givenName
  familyName
  team { ${PublicTeamGqProps} }
`;
